<template>
    <div class="thousand_layout" id="ValutBox">
        <div class="right_box">
            <div class="flex_layout_between">
                <h3>{{ $t('vault.WithdrawCards') }}</h3>
            </div>
            <div class="breadcrumb">
                <router-link class="text_gray" :to="{ path: '/vault/buyerpanel' }">{{ $t('vault.CardHobbyVault') }}</router-link>
                <span class="el-icon-arrow-right text_gray"></span>
                <router-link class="text_gray" :to="{ path: '/vault/myvault/' + vaultWareId }">{{ $t('vault.InVault') }}({{ $t('vault.NotConsigned') }})</router-link>
                <span class="el-icon-arrow-right text_gray"></span>
                {{ $t('vault.WithdrawCards') }}
            </div>

            <div class="agencyAddressBox">{{stockFrom}}
                <div class="agencyAddress" v-if="0">
                    <!-- 提货 Vault仓地址 -->
                    <div>
                        <span>{{ agencyProvice.AgencyName }}</span>
                    </div>
                    <div class="address">
                        <span>{{ agencyProvice.AgencyAddress }}</span>
                        <span>{{ agencyProvice.City }}</span>
                        <span>{{ agencyProvice.Provice }}</span>
                        <span>{{ agencyProvice.Nation }}</span>
                        <span>{{ agencyProvice.ZipCode }}</span>
                    </div>
                    <div>{{ agencyProvice.Telephone }}</div>
                </div>
                <div class="text_blue text_lg">
                    <!-- 提貨说明 -->
                    {{ $t('vault.thelocalwarehouse') }}
                </div>
            </div>
            <div class="flex_layout_start items-center">
                <h3 class="text_xl">{{ $t('vault.CardstoWithdraw') }}</h3>
                <div>{{ stockFrom.CardIds.length }}/{{ checkMax }}</div>
            </div>
            <div class="vault_list_box">
                <div class="headlist">
                    <div class="first">{{ $t('base.item') }}</div>
                    <div>{{ $t('vault.EstimatedValue') }}</div>
                    <div>{{ $t('base.status') }}</div>
                    <div>{{ $t('base.operate') }}</div>
                </div>
            </div>
            <div class="vault_list_box infinite_scroll" v-infinite-scroll="getCommodityList" :infinite-scroll-distance="100" :infinite-scroll-disabled="disabled" style="margin-bottom: 40px;">
                <el-checkbox-group v-model="stockFrom.CardIds" :max="checkMax">
                    <div class="content_list" v-for="(item, index) in valutList" :key="index" v-if="valutList && valutList.length > 0">
                        <div class="first">
                            <el-checkbox :label="item.Id" style="position:absolute;" :disabled="SetStatusEnumVal(item, 'pickUp').key != 2"></el-checkbox>
                            <div class="pickupCard">
                                <div class="pickupCardImg">
                                    <el-image style="width:80px" :src="item.TitImg + '?imageView2/2/w/350'" fit="contain"></el-image>
                                </div>
                                <div class="pickupCardText">
                                    <strong class="line-clamp-2">{{ item.Title }}</strong>
                                    <div>{{ item.ProfessionalGrader }} {{ item.Grade }}</div>
                                </div>
                            </div>
                        </div>
                        <div>USD {{ ThousandAndDecimal(item.UsdPrice) }}</div>
                        <div>{{ SetStatusEnumVal(item, "pickUp").label }}</div>
                        <div class="last">
                            <router-link :to="{ path: `/vaultdetails/${item.Id}` }">{{ $t('base.viewDetails') }}</router-link>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <div class="btnBox">
                <el-input v-model="stockFrom.Remark" :placeholder="$t('vault.AddNotes')"></el-input>
                <el-button type="primary" :disabled="!stockFrom.CardIds.length" @click="batchOperate">{{ $t('vault.RequestWithdrawal') }}</el-button>
            </div>

        </div>
    </div>
</template>

<script>

import commonEventJs from "@/common/CommonEventJs.js";
import { getInfo, isVaultHouse } from "@/api/public";
import VaultDetail from '@/components/dialog/vaultDetail';
export default {
    components: {
        VaultDetail
    },
    data() {

        return {
            checkMax: 20,
            userInfo: getInfo(),
            PageIndex: 1,
            PageSize: 10,
            isCount: false,
            valutList: [],
            pageTotal: '',
            agencyProvice: '',
            VaultStatistics: '',
            noMore: false,
            loading: false,
            stockFrom: {
                MemberId: '',
                CardIds: [],
                ValutId: '',
                PickupType: 2,
                StoreId: '',
                StoreName: '',
                Remark: '',
            }
        }
    },
    created: function () {
        var that = this;
        that.userInfo = getInfo()
        that.VaultStatistics = isVaultHouse()
        if (that.$route.params.id) {
            that.vaultWareId = that.$route.params.id
            that.GetAgency()
        }


    },
    mounted: function () {
        var that = this;
        //that.getCommodityList()
    },
    computed: {
        disabled() {
            return this.noMore || this.loading
        },
        SetStatusEnumVal() {
            var that = this;
            return function (item, type) {
                var seachType = that.Status;//1查询未上架的商品(status=0||status=1)    2查询代卖中的商品(委托中的)   Status=4  未委托卡片
                /*
                    item.ApplyStatus 委托的状态 0待委托   1申请中   2委托中 
                    item.Status 待入库=0,  寄存中 = 1,  提货中 = 2,  已提货 = 3,  上架中 = 4,已售出 = 5
                */
                //console.log("seachType", seachType, type)
                var ApplyStatusEnum = that.ApplyStatusEnum;
                var StatusEnum = that.StatusEnum;
                var data = {};
                if (type == 'inStock') {
                    /* type: inStock 在库  */
                    data = {
                        show: true,
                        // 委托中的 区分是否上架、出售
                        //label: seachType == 4 ? (item.Status == 0 ? StatusEnum[item.Status] : ApplyStatusEnum[item.ApplyStatus]) : (item.Status == 1 ? ApplyStatusEnum[item.ApplyStatus] : StatusEnum[item.Status]),
                        //key: seachType == 4 ? (item.Status == 0 ? 1 : (item.Status == 1 ? 2 : 0)) : (item.Status == 1 ? item.ApplyStatus : item.Status)

                        // 委托中的 不区分上架、出售状态
                        label: seachType == 4 ? (item.Status == 0 ? StatusEnum[item.Status] : ApplyStatusEnum[item.ApplyStatus]) : ApplyStatusEnum[item.ApplyStatus],
                        key: seachType == 4 ? (item.Status == 0 ? 1 : (item.Status == 1 ? 2 : 0)) : item.ApplyStatus
                    };
                }
                else if (type == 'pickUp') {
                    /* type: pickUp 提货 */
                    data = {
                        show: true,
                        label: item.ApplyStatus != 0 ? ApplyStatusEnum[item.ApplyStatus] : StatusEnum[item.Status],
                        key: item.ApplyStatus != 0 ? 1 : (item.Status == 0 ? 1 : (item.Status == 1 ? 2 : 0))
                    };
                }
                return data
            }
        },
        ApplyStatusEnum() {
            return {
                0: this.$t('vault.AwaitingConsignment'),
                1: this.$t('vault.ApplicationPending'),
                2: this.$t('vault.Accepted'),//委托中
            }
        },
        StatusEnum() {
            return {
                0: this.$t('vault.Processing'),//待入库
                1: this.$t('vault.TagInVault'),
                2: this.$t('vault.WithdrawalInProgress'),
                3: this.$t('vault.Withdrawn'),
                4: this.$t('vault.ListingInProgress'),
                5: this.$t('vault.Sold')
            }
        },
        ThousandAndDecimal() {
            return function (num) {
                //金额千分位
                return commonEventJs.thousandAndDecimal(num);
            }
        }
    },
    methods: {
        getDetail(obj, val) {
            //console.log(obj, val)
            let that = this
            let _data = {
                Id: { Id: obj._id }
            }
            that.getData('GetCommodityById', _data)
        },
        GetAgency() {
            const that = this
            let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, memberSource: "" }
            that.VaultStatistics.map(item => {
                if (item.VaultId == that.vaultWareId) {
                    data.memberSource = item.AreaCode
                }
            })
            this.$get(this.$interface.GetAgency, data).then(res => {
                if (res.result != 0) {
                    let address = res.data.AgencyAddress
                    if(res.data.City){
                        address=address+","+res.data.City
                    }
                    if(res.data.Provice){
                        address=address+","+res.data.Provice
                    }
                    if(res.data.Nation){
                        address=address+","+res.data.Nation
                    }
                    that.agencyProvice = res.data
                    that.stockFrom.MemberId = that.userInfo.MappingUserId
                    that.stockFrom.StoreId = res.data.Id
                    that.stockFrom.StoreName = res.data.Nation
                    that.stockFrom.ValutId = that.vaultWareId
                    that.stockFrom.ConsigneeName = address
                    that.stockFrom.ConsigneePhone = res.data.Telephone
                }
            })
        },

        getCommodityList() {
            const that = this
            if (that.loading || that.noMore) return
            let data = { PageIndex: that.PageIndex, PageSize: that.PageSize, SortType: 1, Status: 4, MemberId: that.userInfo.MappingUserId, VaultId: that.vaultWareId, Title: '' }
            that.loading = true
            that.$get(this.$interface.GetCommodityByMemberId, data).then(res => {
                if (res.Result > 0) {
                    that.pageTotal = res.Count
                    if (res.Data && res.Data.length > 0) {
                        that.PageIndex = that.PageIndex + 1
                        that.valutList = [...that.valutList, ...res.Data]
                        // 已加载全部数据，停止加载
                        if (that.valutList.length >= that.pageTotal) {
                            that.noMore = true
                        }
                    } else {
                        that.noMore = true
                    }
                } else {
                    that.noMore = true
                }
                that.loading = false
            }).catch(() => {
                that.loading = false
            })
        },
        batchOperate() {
            const that = this
            let data = that.stockFrom
            that.$post(this.$interface.PickupApplyAdd, data).then(res => {
                if (res.Result == 1) {
                    that.$router.push({ path: "/vault/OutboundList/" + that.vaultWareId })
                } else {
                    that.$message.error(res.Msg);
                }
            })
        }





    },
    destroyed: function () {
        var that = this;
    }
};
</script>


<style scoped>
@import "../../../static/css/usertabslist.css";
@import "../../../static/css/vault/vault.css";

.agencyAddressBox {
    margin: 20px 0;
}

.agencyAddress {
    border: 2px dashed #5f6dae;
    position: relative;
    display: inline-block;
    padding: 16px;
    min-width: 330px;
    min-height: 100px;
    font-size: 16px;
    margin-bottom: 20px;
}

.agencyAddress>div+div {
    margin-top: 10px;
}

.address span+span::before {
    content: ", ";
}

.agencyAddress::after {
    content: "";
    border: 15px solid transparent;
    position: absolute;
    border-bottom-color: #5f6dae;
    border-right-color: #5f6dae;
    right: -2px;
    bottom: -2px;
}

.agencyAddress::before {
    content: "";
    border: 1px solid #fff;
    border-top: none;
    border-left: none;
    width: 4px;
    height: 10px;
    position: absolute;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    bottom: 3px;
    right: 5px;
    z-index: 2;
}

.vault_list_box>div .first {
    position: relative;
}

.pickupCard {
    padding-left: 16px;
}

.infinite_scroll {
    height: 800px;
    overflow-y: auto;
}

.btnBox {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding: 10px;
    z-index: 9;
    min-height: 60px;
    display: flex;
    gap: 2%;
    box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.02);
}

/deep/ .el-checkbox__label {
    display: none;
}

/* 重置 el-checkbox-group 上被全局 .vault_list_box>div 误加的 grid */
.infinite_scroll>.el-checkbox-group {
    display: block;
}

/* 将 grid 应用到每行 content_list */
.infinite_scroll .content_list {
    display: grid;
    grid-template-columns: auto 14% 14% 14%;
    gap: 2%;
    text-align: center;
}

/* 保持 header 行不受影响 */
.vault_list_box:not(.infinite_scroll)>.headlist {
    display: grid;
    grid-template-columns: auto 14% 14% 14%;
    gap: 2%;
    text-align: center;
}

.flex_layout_start {
    margin-top: 16px;
    gap: 8px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Vault/Outbound.vue